import { listHostedContents } from './chats.mjs';

const DOWNLOADABLE_TYPES = new Set([
  'reference',
  'application/octet-stream',
]);

export function isDownloadable(att) {
  if (!att) return false;
  if (DOWNLOADABLE_TYPES.has(att.contentType)) return true;
  return !!att.contentUrl && !att.contentType?.startsWith('application/vnd.microsoft.card');
}

export function urlToShareId(url) {
  // Cross-runtime UTF-8 → base64url. Works in Node 18+ and any modern browser.
  const bytes = new TextEncoder().encode(url);
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  const b64 = (typeof btoa === 'function' ? btoa(binary) : Buffer.from(bytes).toString('base64'));
  const b64url = b64.replace(/=+$/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  return `u!${b64url}`;
}

export async function fetchDriveItemMetadata(graph, sharedUrl) {
  const shareId = urlToShareId(sharedUrl);
  return graph.request(`/shares/${shareId}/driveItem?$select=id,name,size,file,folder,@microsoft.graph.downloadUrl,parentReference`);
}

export async function downloadAttachment(graph, att) {
  if (!att.contentUrl) return null;
  const shareId = urlToShareId(att.contentUrl);
  return graph.download(`/shares/${shareId}/driveItem/content`);
}

export async function downloadHostedContent(graph, chatId, messageId, hostedContentId) {
  const path = `/chats/${encodeURIComponent(chatId)}/messages/${encodeURIComponent(messageId)}/hostedContents/${encodeURIComponent(hostedContentId)}/$value`;
  return graph.download(path);
}

export function extractHostedContentIds(bodyHtml) {
  if (!bodyHtml) return [];
  const ids = new Set();
  const re = /hostedContents\/([^/"'\s]+)\/\$value/gi;
  let m;
  while ((m = re.exec(bodyHtml)) != null) ids.add(m[1]);
  return [...ids];
}

export function rewriteBodyHtml(bodyHtml, hostedContentMap) {
  if (!bodyHtml) return bodyHtml;
  return bodyHtml.replace(
    /(?:https?:[^"'\s]+)?hostedContents\/([^/"'\s]+)\/\$value/gi,
    (match, id) => hostedContentMap.get(id) || match,
  );
}

export async function collectHostedContents(graph, chatId, messageId) {
  const items = [];
  for await (const hc of listHostedContents(graph, chatId, messageId)) {
    items.push(hc);
  }
  return items;
}
